var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRoundLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.25C6.57107 8.25 8.25 6.57107 8.25 4.5C8.25 2.42893 6.57107 0.75 4.5 0.75C2.42893 0.75 0.75 2.42893 0.75 4.5C0.75 5.09988 0.890856 5.66686 1.1413 6.16968C1.20785 6.3033 1.23 6.45602 1.19142 6.60023L0.968067 7.43499C0.871109 7.79737 1.20263 8.12889 1.56501 8.03193L2.39977 7.80858C2.54397 7.77 2.6967 7.79215 2.83032 7.8587C3.33314 8.10914 3.90012 8.25 4.5 8.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3 3.9375H6",
    stroke: "#76D6FF",
    strokeWidth: 0.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3 5.25H5.0625",
    stroke: "#76D6FF",
    strokeWidth: 0.5625,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRoundLine);
export default __webpack_public_path__ + "static/media/chat-round-line.ae5a60d84a20faed97f376fb5a5de75d.svg";
export { ForwardRef as ReactComponent };